import { QueryClient } from '@tanstack/react-query'

/**
 * Global QueryClient for React Query
 *
 * Configured for model discovery with:
 * - 5-minute stale time (frontend cache layer)
 * - 10-minute cache time (data retention)
 * - 2 retries for failed requests
 * - No refetch on window focus (models don't change frequently)
 * - Refetch on reconnect (ensure fresh data after offline)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - frontend cache layer
      gcTime: 10 * 60 * 1000, // 10 minutes - renamed from cacheTime in v5
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  }
})
